import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Field, reduxForm } from "redux-form"
import { Translate, getTranslate, getActiveLanguage } from "react-localize-redux"

import {
	createValidator,
	email,
	match,
	required,
	minLength,
	maxLength,
	password,
	isValidDate,
	integer,
	noVnChars,
	noSpecialChars,
	fixedLength,
} from "../../helpers/validator"
import CheckField from "../components/fields/CheckField"
import TextField from "../components/fields/TextField"
import DatePickerField from "../components/fields/DatePickerField"
import Button from "../components/forms/Button"

import { getSysCodeOptions } from "../../redux/modules/SystemCode"
import { bindActionCreators } from "redux"

const validate = createValidator({
	email: [required, email],
	firstName: [required, noVnChars, noSpecialChars],
	lastName: [required, noVnChars, noSpecialChars],
	dob: [isValidDate],
	mobileNo: [required, minLength(8)],
	nationality: [required],
	consentAgreement: [],
	termsAndConditions: [required],
	countryOfResidence: [required],
})

export const formId = "sign-up"
class SignUpForm extends React.Component {
	constructor(props) {
		super(props)
	}
	render() {
		const { error, handleSubmit, pristine, translate, submitting } = this.props

		return (
			<form name="form" onSubmit={handleSubmit} className="row form">
				<div className="col-12">
					<Field
						name="firstName"
						type="text"
						autocomplete="given-name"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._firstName")}
					/>
					<Field
						name="lastName"
						type="text"
						autocomplete="family-name"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._lastName")}
					/>
					<Field
						name="email"
						type="email"
						autocomplete="email"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._email")}
					/>
					<Field
						name="mobileNo"
						required={true}
						type="tel"
						inputMode="numeric"
						pattern="[0-9]*"
						minLength={8}
						disabled={submitting}
						component={TextField}
						label={"Mobile Number"}
						normalize={(value) => value.replace(/[^0-9]/g, "")}
					/>

					<Field
						name="dob"
						required={true}
						disabled={submitting}
						component={DatePickerField}
						disabledYear={false}
						label={translate("_shared.form.label._dob")}
					/>
					<div className="row px-3 ml-1 color-text-2">
						<div className="mt-2 mb-2 font-sub">
							By signing up as a member, I agreed to be contacted via
							telephone, SMS, emails or any other means for member
							privileges, ongoing promotions, reward redemptions or any
							membership related matters. Japan Foods Holding Ltd. will keep
							your information adhering to its{" "}
							<a target="_blank" href="https://jfh.com.sg/html/protect.php">
								Protection
							</a>{" "}
							and{" "}
							<a target="_blank" href="https://jfh.com.sg/html/privacy.php">
								{" "}
								Privacy Policy
							</a>
							:{" "}
						</div>
						<div className="row px-3 color-text-2">
							<Field
								id="communicationPreferences"
								name="communicationPreferences"
								type="checkbox"
								disabled={submitting}
								component={CheckField}
								label={"Email, SMS & Mail"}
								className="font-sub mr-2"
							/>
						</div>
						<Field
							id="tncAgree"
							name="tncAgree"
							type="checkbox"
							disabled={submitting}
							component={CheckField}
							label={
								<span>
									By signing up as a member, I agree with Japan Foods
									Holding Ltd. Terms & Condition. (Click{" "}
									<a
										target="_blank"
										href="https://www.jfh.com.sg//html/membershiptermsandconditions.php">
										here
									</a>{" "}
									to view T&C's)
								</span>
							}
							className="font-sub mt-2"
						/>
					</div>
					{error && (
						<div className="my-2 text-left">
							<span className="form-error">{error}</span>
						</div>
					)}
				</div>

				<div className="col-12 text-center mt-4">
					<Button
						type="submit"
						className="btn btn-primary"
						disabled={pristine}
						loading={submitting}>
						<Translate id={submitting ? "_Submitting" : "_sign_up"} />
					</Button>
				</div>
			</form>
		)
	}
}

SignUpForm.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	translate: PropTypes.func.isRequired,
	invalid: PropTypes.bool.isRequired,
	submitting: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ locale }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
})

const mapDispatchTpProps = (dispatch) => ({
	getSysCodeOptions: bindActionCreators(getSysCodeOptions, dispatch),
})

export default reduxForm({
	form: formId, // a unique identifier for this form
	validate,
	enableReinitialize: true,
	destroyOnUnmount: false,
})(connect(mapStateToProps, mapDispatchTpProps)(SignUpForm))



// WEBPACK FOOTER //
// ./src/views/modules/SignUpForm.js